import { render, staticRenderFns } from "./AccreditedSchoolsData.vue?vue&type=template&id=bab32d78"
import script from "./AccreditedSchoolsData.vue?vue&type=script&lang=js"
export * from "./AccreditedSchoolsData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports